<template lang="pug">
  title-tab(
    :msg="$t('title.voucher')" 
    :hadData="hadData"
  )
    v-row(no-gutters)
      v-col.pt-3(cols='12')
        add-voucher-section(@success='loadDefault')
      v-col.pt-3(cols='12')
        v-divider
      v-col.pt-3(cols='12', md='4')
        select-voucher-scope(
          v-model='scope'
          @input='load'
        ) 
    v-row(no-gutters)
      v-col(cols=12, :md="showPromotion ? 7 : 12").pt-3
        n-data-table-card-result(
          :headers='headers'
          :items='items'
          :meta='meta' 
          @nextpage='nextpage'
        )
          template(#item.image_url='{ value }')
            v-list-item-avatar
              v-img(:src='value')
          template(#item.status='{value}')
            | {{ $t(value) }}
          template(#item.voucher_type='{value}')
            | {{ $t(value.split('_').join('-')) }}
          template(#item.created_at='{value}')
            | {{ value | dateFormat }}
          template(#item.expired_at='{value}')
            | {{ value | dateFormat }}
      
      v-col(v-if="showPromotion" cols=12, md=5).px-2
        v-card.mt-3(flat)
          v-row.mx-2
            v-col
              h5 {{ $t('promotion') }}
          v-divider
          div.promotion-container
            div(
              v-for='(item, i) in promotions'
              :key='i'
            )
              card-promotion(:item="item").card-promotion
    dialog-add-voucher(ref='DialogAddVoucher')
</template>
<script>  
import { vouchers as apiVouchers } from '@/apis'
import SelectVoucherScope from './childs/SelectVouchersScope'
import dialogAddVoucher from './childs/DialogAddVoucher' 
import AddVoucherSection from './childs/AddVoucherSection.vue'
import CardPromotion from '@/components/Promotion/CardPromotion'

export default { 
  components : {
    SelectVoucherScope,
    dialogAddVoucher,
    AddVoucherSection,
    CardPromotion,
  },
  data: () => ({
    headers:[
      { text:'table.name',value:'name'},
      { text:'table.image-url',value:'image_url'},
      { text:'table.code',value:'code' },
      { text:'table.status',value:'status'},
      { text:'table.type',value:'voucher_type' },
      { text:'table.activated-at',value:'activated_at' },
      { text:'table.expired-at', value:'expired_at' },
    ],
    items : [],
    page:1,
    meta:{}, 
    hadData:false,
    dateRange : ['',''],
    scope:'AVAILABLE',
    promotions: [], 
  }),
  computed : {
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    showPromotion () {
      return !this.userProfile.stucked_voucher_id && !!this.promotions.length
    },
  }, 
  async mounted () {
    await this.load ()
  },
  methods : { 
    async loadDefault () {
      this.scope = 'AVAILABLE'
      await this.load()
    },
    setDateRange (value) { 
      this.dateRange = value
      if(this.dateRange[1]!==''){
        this.$ga.event('Button', 'SelectDateRange', 'CreditPage','' )
        this.load ()
      } 
    },
    async load (params = {}) {  
      params = {
        page : this.page,
        start_date : this.dateRange[0],
        end_date : this.dateRange[1]
      }
      if(this.scope) {
        params.scope = this.scope
      }

      this.hadData=false   
      const [err,data,,meta] = await apiVouchers.get(params)
      this.hadData=true   
      
      if(err) { 
        this.$alert('',err,'warning')  
        return
      } 

      this.meta = meta
      this.items = data 

      await this.getVouchers()
    },

    async nextpage (value) {
      this.page = value
      await this.load ()
    },
    openDialogAddVoucher () {
      this.$refs.DialogAddVoucher.open()
    }, 
    async getVouchers () {  
      const [,data,,] = await apiVouchers.list({'type': 'voucher'})

      this.promotions = data
    },
  }
}
</script>
<style scoped>
.promotion-container {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-auto-rows: 1fr;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 12px;
  padding-bottom: 12px;
  gap: 12px;
}
</style>